import { globalStyleObj } from "@/app/assets/styles";
import {
  LabelText,
  NormalBrowseFileInputFiled,
  NormalTextInputField,
} from "@/components";
import { Skeleton } from "@/components/ui/skeleton";
import React, { useMemo } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";

const OurServicesPageCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  addOnlyValueRepeaterChange,
  removeOnlyValueRepeaterChange,
  updateOnlyValueRepeaterChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab == "section-1" && (
        <>
          {/* Banner Section */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="our-services-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("our-services-banner-image", id)
                  : handleImageChange("our-services-banner-image", "")
              }
              selectedFileId={formData?.["our-services-banner-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="our-services-banner-heading"
            fieldName="our-services-banner-heading"
            placeholderText="Heading"
            inputValue={formData?.["our-services-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="our-services-banner-sub-heading"
            fieldName="our-services-banner-sub-heading"
            placeholderText="Description"
            inputValue={formData?.["our-services-banner-sub-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* --------------------------------- */}
          {/* --- Saperate Line --- */}
          {/* --------------------------------- */}
          <div className="w-full my-10 border border-dashed border-[#00000020] dark:border-[#ffffff20]" />

          {/* Services Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Services Heading"
            fieldId="our-services-list-heading"
            fieldName="our-services-list-heading"
            placeholderText="Services Heading"
            inputValue={formData?.["our-services-list-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Services Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Services Description"
            fieldId="our-services-list-description"
            fieldName="our-services-list-description"
            placeholderText="Services Description"
            inputValue={formData?.["our-services-list-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* --------------------------------- */}
          {/* --- Saperate Line --- */}
          {/* --------------------------------- */}
          <div className="w-full my-10 border border-dashed border-[#00000020] dark:border-[#ffffff20]" />

          {/* Form Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={false}
            labelText="Form Heading"
            fieldId="our-services-form-heading"
            fieldName="our-services-form-heading"
            placeholderText="Form Heading"
            inputValue={formData?.["our-services-form-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Form Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Form Description"
            fieldId="our-services-form-description"
            fieldName="our-services-form-description"
            placeholderText="Form Description"
            inputValue={formData?.["our-services-form-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* --------------------------------- */}
          {/* --- Saperate Line --- */}
          {/* --------------------------------- */}
          <div className="w-full my-10 border border-dashed border-[#00000020] dark:border-[#ffffff20]" />

          {/* Our Commits Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Our Commits Heading"
            fieldId="our-commits-heading"
            fieldName="our-commits-heading"
            placeholderText="Our Commits Heading"
            inputValue={formData?.["our-commits-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Our Commits Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Our Commits Sub Heading"
            fieldId="our-commits-sub-heading"
            fieldName="our-commits-sub-heading"
            placeholderText="Our Commits Sub Heading"
            inputValue={formData?.["our-commits-sub-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Our Commits Points */}
          <div className="w-full mt-5 flex flex-col gap-2 xl:flex-row justify-between lg:gap-5">
            {isFetching ? (
              <Skeleton className="w-[150px] h-[30px] rounded-md" />
            ) : (
              <LabelText
                text="Our Commit Points"
                htmlForId="our-commit-key-points"
                star={false}
                translateField={true}
              />
            )}

            <div className="w-full lg:max-w-[500px]">
              {formData?.["our-commit-key-points"] &&
                formData?.["our-commit-key-points"].length > 0 && (
                  <div className="w-full">
                    {formData?.["our-commit-key-points"].map((item, index) => (
                      <div key={index} className="w-full flex gap-2 mb-5">
                        {isFetching ? (
                          <Skeleton className="w-full flex-1 h-[40px] rounded-md" />
                        ) : (
                          <NormalTextInputField
                            isFetching={isFetching}
                            isTextArea={true}
                            fieldId={`our-commit-key-point-${activeTab}-${index}`}
                            placeholderText={`Key Point ${index + 1}`}
                            inputValue={
                              formData?.["our-commit-key-points"]?.[index] || ""
                            }
                            onChangeTextInputField={(e) =>
                              updateOnlyValueRepeaterChange(
                                "our-commit-key-points",
                                index,
                                e.target.value
                              )
                            }
                            extraContainerClasses="w-full"
                            // translateField={true}
                            // extraContainerClasses="mt-5"
                          />
                        )}

                        {isFetching ? (
                          <Skeleton className="w-[30px] h-[40px] rounded-md" />
                        ) : (
                          <button
                            type="button"
                            onClick={() =>
                              removeOnlyValueRepeaterChange(
                                "our-commit-key-points",
                                index
                              )
                            }
                            className="flex justify-center items-start"
                          >
                            <MdOutlineDeleteForever
                              size={25}
                              className="text-red-500 hover:scale-[1.2] transition-300"
                            />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}

              {isFetching ? (
                <Skeleton className="w-[120px] h-[40px] rounded-md" />
              ) : (
                <button
                  type="button"
                  onClick={() =>
                    addOnlyValueRepeaterChange("our-commit-key-points")
                  }
                  className={`${globalStyleObj.flexCenter} transition-300 gap-2 rounded-[4px] ${colorGrade.bgColor} ${colorGrade.hoverBgColor} ${colorGrade.textColor} px-5 py-2 font-poppins-rg text-[13px] tracking-wide hover:text-white w-full sm:max-w-[120px] dark:text-light-weight-800`}
                >
                  Add
                </button>
              )}
            </div>
          </div>

          {/* --------------------------------- */}
          {/* --- Saperate Line --- */}
          {/* --------------------------------- */}
          <div className="w-full my-10 border border-dashed border-[#00000020] dark:border-[#ffffff20]" />

          {/* Your Commits Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Your Commits Heading"
            fieldId="your-commits-heading"
            fieldName="your-commits-heading"
            placeholderText="Your Commits Heading"
            inputValue={formData?.["your-commits-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Your Commits Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Your Commits Sub Heading"
            fieldId="your-commits-sub-heading"
            fieldName="your-commits-sub-heading"
            placeholderText="Your Commits Sub Heading"
            inputValue={formData?.["your-commits-sub-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Your Commits Points */}
          <div className="w-full mt-5 flex flex-col gap-2 xl:flex-row justify-between lg:gap-5">
            {isFetching ? (
              <Skeleton className="w-[150px] h-[30px] rounded-md" />
            ) : (
              <LabelText
                text="Your Commit Points"
                htmlForId="your-commit-key-points"
                star={false}
                translateField={true}
              />
            )}

            <div className="w-full lg:max-w-[500px]">
              {formData?.["your-commit-key-points"] &&
                formData?.["your-commit-key-points"].length > 0 && (
                  <div className="w-full">
                    {formData?.["your-commit-key-points"].map((item, index) => (
                      <div key={index} className="w-full flex gap-2 mb-5">
                        {isFetching ? (
                          <Skeleton className="w-full flex-1 h-[40px] rounded-md" />
                        ) : (
                          <NormalTextInputField
                            isFetching={isFetching}
                            isTextArea={true}
                            fieldId={`your-commit-key-point-${activeTab}-${index}`}
                            placeholderText={`Key Point ${index + 1}`}
                            inputValue={
                              formData?.["your-commit-key-points"]?.[index] ||
                              ""
                            }
                            onChangeTextInputField={(e) =>
                              updateOnlyValueRepeaterChange(
                                "your-commit-key-points",
                                index,
                                e.target.value
                              )
                            }
                            extraContainerClasses="w-full"
                            // translateField={true}
                            // extraContainerClasses="mt-5"
                          />
                        )}

                        {isFetching ? (
                          <Skeleton className="w-[30px] h-[40px] rounded-md" />
                        ) : (
                          <button
                            type="button"
                            onClick={() =>
                              removeOnlyValueRepeaterChange(
                                "your-commit-key-points",
                                index
                              )
                            }
                            className="flex justify-center items-start"
                          >
                            <MdOutlineDeleteForever
                              size={25}
                              className="text-red-500 hover:scale-[1.2] transition-300"
                            />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}

              {isFetching ? (
                <Skeleton className="w-[120px] h-[40px] rounded-md" />
              ) : (
                <button
                  type="button"
                  onClick={() =>
                    addOnlyValueRepeaterChange("your-commit-key-points")
                  }
                  className={`${globalStyleObj.flexCenter} transition-300 gap-2 rounded-[4px] ${colorGrade.bgColor} ${colorGrade.hoverBgColor} ${colorGrade.textColor} px-5 py-2 font-poppins-rg text-[13px] tracking-wide hover:text-white w-full sm:max-w-[120px] dark:text-light-weight-800`}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OurServicesPageCMSForm;
